<div #chartgdsbalancesingle class="w-full h-60 md:h-[21rem]"></div>
@if (canChangeTimePeriod) {
  <mat-button-toggle-group
    [hideSingleSelectionIndicator]="true"
    [formControl]="balanceChartontrol"
    class="relative flex flex-row justify-center md:justify-start -top-[35px] my-button-toggle-group"
  >
    <mat-button-toggle value="3m">3M</mat-button-toggle>
    <mat-button-toggle value="6m">6M</mat-button-toggle>
    @if (goalYears >= 1) {
      <mat-button-toggle value="1y">1A</mat-button-toggle>
    }
    @if (goalYears >= 2) {
      <mat-button-toggle class="hidden xl:block" value="2y">2A</mat-button-toggle>
    }
    @if (goalYears >= 3) {
      <mat-button-toggle class="hidden xl:block" value="3y">3A</mat-button-toggle>
    }
    <mat-button-toggle value="all">TODO</mat-button-toggle>
    <mat-button-toggle value="thisyear">{{ thisYear }}</mat-button-toggle>
    @if (wasTheGoalCreatedThePastYear) {
      <mat-button-toggle class="hidden xl:block" value="pastyear">{{ pastYear }}</mat-button-toggle>
    }
    @if (wasTheGoalCreatedThePastPastYear) {
      <mat-button-toggle class="hidden xl:block" value="pastPastyear">{{
        pastPastYear
      }}</mat-button-toggle>
    }
  </mat-button-toggle-group>
}
